import * as angular from 'angular';
import * as _ from 'lodash';
import { States } from "../../shared/config/constant.module";
import template from './sendNotification.tpl.html';
import { Plant } from "../../models/navigation";
import UIUtilityServiceName, { EnumOption, UIUtilityService } from "../../services/utility/uiUtility.service";
import { apsCommands } from "../../shared/dto/aps.commands";
import { apsCommon } from "../../shared/dto/aps.common";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NotificationServiceName, { NotificationService } from "../../services/notifications/notification.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import UserServiceName, { UserService } from "../../services/users/user.service";
import { apsEnums } from "../../shared/dto/aps.enums";

let requires = [UIUtilityServiceName, NotifyServiceName, LoaderServiceName, NotifyServiceName, NavigationServiceName,
  NotificationServiceName, AuthDataServiceName, UserServiceName];

class SendNotificationCtrl {
  plants: Plant[];
  options: EnumOption[];
  notification: apsCommands.SendGlobalNotification;
  form: angular.IFormController;
  users: apsCommon.IdAndName[];
  user: string;
  selectedUsers: apsCommon.IdAndName[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  isAdmin: boolean;
  releaseNote: apsCommands.AddReleaseNoteNotification;
  private notificationService: NotificationService;
  private notifyService: NotifyService;
  private loaderService: LoaderService;

  constructor(
    notificationService: NotificationService,
    navigationService: NavigationService,
    authDataService: AuthDataService,
    loaderService: LoaderService,
    notifyService: NotifyService,
    uiUtilityService: UIUtilityService,
    userService: UserService) {
    this.notificationService = notificationService;
    this.notifyService = notifyService;
    this.loaderService = loaderService;

    this.isAdmin = authDataService.isAdmin();
    var promise = navigationService.getNavigation().then((navigation) => {
      var plants = navigation.plants();
      this.plants = _.filter(plants, (plant) => {
        return authDataService.isPlantAdmin(plant.id);
      });
      if (!this.isAdmin) {
        this.selectedPlant = this.plants[0];
      }
    });

    var startEnum = apsEnums.GlobalNotificationType.EntireCompany;
    var endEnum = apsEnums.GlobalNotificationType.ReleaseNotes;
    if (!this.isAdmin) {
      startEnum = apsEnums.GlobalNotificationType.EntirePlant;
    }
    if(!authDataService.isAPSIOAdmin()){
      endEnum = apsEnums.GlobalNotificationType.Individuals
    }
    this.options = uiUtilityService.getListOptionsFromEnum(apsEnums.GlobalNotificationType, startEnum, endEnum);

    userService.getUsersToNotify().then((users) => {
      this.users = users;
    });

    this.notification = {
      type: startEnum,
      plantId: undefined,
      shopId: undefined,
      userIds: [],
      title: undefined,
      description: undefined,
      url: undefined
    };

    this.releaseNote = {
      title: undefined,
      description: undefined,
    };


    this.selectedUsers = [];

    this.loaderService.loadingPromise(promise);
  }

  userSelected(): void {
    var user = _.find(this.users, { name: this.user });
    if (!user) {
      return;
    }

    this.user = undefined;
    this.selectedUsers.push(user);
  }

  removeUser(user: apsCommon.IdAndName): void {
    _.remove(this.selectedUsers, user);
  }

  typeChanged(): void {
    if (this.showPlants()) {
      this.notification.plantId = _.first(this.plants).id;
    }
  }

  plantChanged(): void {
    this.selectedShop = null;
  }

  showPlants(): boolean {
    return this.notification.type === apsEnums.GlobalNotificationType.EntirePlant
      || this.notification.type === apsEnums.GlobalNotificationType.EntireShop;
  }

  showShops(): boolean {
    return this.notification.type === apsEnums.GlobalNotificationType.EntireShop;
  }

  showIndividuals(): boolean {
    return this.notification.type === apsEnums.GlobalNotificationType.Individuals;
  }

  usersRequired(): boolean {
    if (!this.showIndividuals()) {
      return false;
    }

    return this.selectedUsers.length === 0;
  }

  send(): void {
    if (this.form.$invalid || this.usersRequired()) {
      return;
    }

    this.notification.plantId = this.showPlants() ? this.selectedPlant.id : undefined;
    this.notification.shopId = this.showShops() ? this.selectedShop.id : undefined;

    if (this.notification.type === apsEnums.GlobalNotificationType.ReleaseNotes) {
      this.releaseNote.description = this.notification.description;
      this.releaseNote.title = this.notification.title;
      this.notificationService.sendReleaseNotesNotification(this.releaseNote).then(() => {
        this.notifyService.success('Notification Sent!');
        this.resetNotificationForm();
      }, this.notifyService.handleApiErrors)
      return;
    }


    if (this.showIndividuals()) {
      this.notification.userIds = _.map(this.selectedUsers, 'id');
    } else {
      this.notification.userIds = [];
    }

    this.loaderService.loadingPromise(
      this.notificationService.sendNotification(this.notification)
        .then(() => {
          this.notifyService.success('Notification Sent!');
          this.resetNotificationForm();
        }, this.notifyService.handleApiErrors)
    );
  }

  private resetNotificationForm(): void {
    this.notification.title = '';
    this.notification.description = '';
    this.notification.url = '';
    this.notification.userIds = [];
    this.selectedUsers = [];
    this.form.$setPristine();
  }
}

export default angular.module('aps.controller.sendNotification', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.GLOBAL_NOTIFICATIONS,
      url: '/sendNotification',
      controller: 'SendNotificationCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Send Notification',
        authorizePlantAdmin: true,
        v2Uri: 'aps/settings/globalNotifications'
      }
    });
  })
  .controller('SendNotificationCtrl', SendNotificationCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/notifications/sendNotification.controller.ts